<!-- =========================================================================================
    File Name: Login.vue
    Description: Login Page
    ---------------------------------------------------------------------------------------- -->


<template>
  <div class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center" id="page-login">
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/12 sm:m-0 m-4">
      <vx-card no-shadow>
        <div slot="no-body" class="full-page-bg-color rounded-lg">

          <div class="vx-row no-gutter justify-center items-center">
            <div class="vx-col w-full d-theme-login-bg">
              <div class="px-16 pt-16 pb-10 login-tabs-container">
                <div class="vx-card__title mb-4">
                  <div class="login-form-logo">
                    <router-link :to="`${baseUrl}/home`">
                      <img src="@/assets/images/logo/logo.png" alt="Axis Realty Group Logo" width="100px" />
                    </router-link>
                  </div>
                  <h4 class="login-form-title py-6">Login</h4>
                </div>

                    <login-jwt></login-jwt>

              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>


<script>
import LoginJwt from './LoginJWT.vue'

export default {
  data () {
    return {
      dns: ''
    }
  },
  computed: {
    baseUrl () {
      const path = this.$route.path
      return path.slice(0, ('/'))
    }
  },
  methods: {
  },
  components: {
    LoginJwt
  },
  created () {
    this.dns = window.location.hostname
    this.dns = this.dns.substring(0, this.dns.indexOf('.'))
  }
}
</script>
